import React from 'react';
import * as S from './footer.styles';
import FacebookIcon from '../../../icons/facebook';
import TwitterIcon from '../../../icons/twitter';
import YoutubeIcon from '../../../icons/youtube';
import AppSprite from './app-sprite';
import VerifiedSprite from './verified-sprite';

const FooterGroupLinks = () => {
  return (
    <div className="justifyBetween dF">
      <div className="dF">
        <S.VerifiedAppLink href="https://www.goibibo.com/" target="_blank">
          <VerifiedSprite className="goibibo"> </VerifiedSprite>
        </S.VerifiedAppLink>
        <S.VerifiedAppLink href="https://www.redbus.in/" target="_blank">
          <VerifiedSprite className="redbus"> </VerifiedSprite>
        </S.VerifiedAppLink>
      </div>
      <div className="drGrey">&copy; 2019 ibibogroup All rights reserved</div>
    </div>
  );
};

const FooterAppLinks = () => {
  return (
    <div className="dF justifyBetween alignItemsEnd">
      <S.FollowWrap className="flexCol alignSelfStart">
        <S.AppHead className="fb">Follow Us</S.AppHead>
        <div className="dF">
          <S.FollowLink href="https://www.facebook.com/Goibibo/" target="_blank">
            <FacebookIcon fill="#999999" width="2.5rem" height="2.5rem" />
          </S.FollowLink>
          <S.FollowLink href="https://twitter.com/goibibo" target="_blank">
            <TwitterIcon fill="#999999" width="2.5rem" height="2.5rem" />
          </S.FollowLink>
          <S.FollowLink href="https://www.youtube.com/user/goibibo" target="_blank">
            <YoutubeIcon fill="#999999" width="2.5rem" height="2.5rem" />
          </S.FollowLink>
        </div>
      </S.FollowWrap>
      <S.BookTicketsWrap className="flexCol">
        <S.AppHead className="fb">Book Tickets faster. Download our mobile Apps</S.AppHead>
        <div className="dF">
          <AppSprite
            href="http://app.appsflyer.com/com.goibibo?pid=mobile_site&c=m_header"
            target="_blank"
            className="GoogleApp"
          >
            {' '}
          </AppSprite>
          <AppSprite
            href="https://itunes.apple.com/in/app/goibibo-flight-bus-hotel-booking/id631927169?mt=8"
            target="_blank"
            className="IphoneApp"
          ></AppSprite>
          <AppSprite
            href="http://www.windowsphone.com/en-in/store/app/goibibo/6f16a6ec-3b7e-4782-9f74-57f75a4cc1a3"
            target="_blank"
            className="WindowApp"
          ></AppSprite>
        </div>
      </S.BookTicketsWrap>
      <div className="dF">
        <VerifiedSprite className="verified"> </VerifiedSprite>
        <VerifiedSprite className="amerexp"> </VerifiedSprite>
        <VerifiedSprite className="master"> </VerifiedSprite>
        <VerifiedSprite className="visa"> </VerifiedSprite>
        <VerifiedSprite className="payu"> </VerifiedSprite>
        <VerifiedSprite className="rupay"> </VerifiedSprite>
        <VerifiedSprite className="iata"> </VerifiedSprite>
      </div>
    </div>
  );
};

// export const RoutesLinks = ({ horizontalFooterLinks }) => {
//   return (
//     <>
//       <div className="flexCol grey">
//         {horizontalFooterLinks && horizontalFooterLinks.map((linksBlock, index) =>
//           linksBlock && linksBlock.links_data && <div className="dF padT5 padB5" key={index} >
//             <S.RoutesHead className="grey fb">{`${linksBlock.block_title}:`}</S.RoutesHead>
//             {linksBlock && linksBlock.links_data && linksBlock.links_data.map((link, index) =>
//               <span key={index}>
//                 <S.RoutesLink href={link.link} className="padL5 padR5 grey">{link.name}</S.RoutesLink>
//                 <span className="padLR5">|</span>
//               </span>)}
//           </div>)}
//       </div>
//     </>
//   );
// };

const Footer = ({ html = '' }) => {
  return (
    <>
      {html ? (
        <S.FooterWrap
          className="dF drGrey justifyBetween"
          dangerouslySetInnerHTML={{ __html: html }}
        ></S.FooterWrap>
      ) : null}
      {/* {horizontalFooterLinks.length > 0 ?
        <S.FooterWrap>
          <RoutesLinks horizontalFooterLinks={horizontalFooterLinks} />
        </S.FooterWrap> : null} */}
      <S.FooterWrap>
        <FooterAppLinks />
      </S.FooterWrap>
      <S.FooterWrap>
        <FooterGroupLinks />
      </S.FooterWrap>
    </>
  );
};

export default Footer;
